"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JUSTIFICATIVA_SALDO_ABERTURA = exports.SITUACOES_INVENTARIO = void 0;
exports.SITUACOES_INVENTARIO = ['EM_CONTAGEM', 'AGUARDANDO_APROVACAO', 'AJUSTADO', 'DESCARTADO'];
/** Justificativa fixa dos movimentos de saldo de abertura (D-26). */
exports.JUSTIFICATIVA_SALDO_ABERTURA = 'Saldo de abertura';
//# sourceMappingURL=estoque-inventario.js.map